import React, { forwardRef, useEffect, useState } from 'react'
import { CustomModal } from '@components'
import { Box, Typography, FormControl, InputLabel, Select, MenuItem, OutlinedInput, InputAdornment } from '@mui/material'
import { useDispatch } from 'react-redux'
import { apiBuySellPowerOrder } from '@store'
import { showToast } from '@utils'

const Sell = forwardRef(({ handleClose, selectedContract, user }, ref) => {
    const dispatch = useDispatch()

    const [state, setState] = useState({
        market: 'CH',
        type: 'sell',
        price_selected: '',
        seller: user?.CompanyShort,
        buyer: '',
        deliverypoint: '',
        volume: '',
        exitpoint: '',
        price_percent: '100',
        ordertype: 'internal',
        currency: 'CHF',
        sym: selectedContract.name,
    })
    const [submitting, setSubmitting] = useState(false) // <-- added

    useEffect(() => {
        if (user?.CanSellElectricityTo?.length > 0) {
            setState((prevState) => ({
                ...prevState,
                buyer: user.CanSellElectricityTo[0]
            }));
        }
    }, [user]);

    const handleChange = (e) => {
        const { name, value } = e.target
        setState({
            ...state,
            [name]: value
        })
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (submitting) return;              // <-- added
        setSubmitting(true);                 // <-- added
        const volume = parseFloat(state.volume)
        const ask = parseFloat(selectedContract.ask)

        const data = {
            ...state,
            volume: volume,
            price: { ask: ask },
        }

        const res = await dispatch(apiBuySellPowerOrder(data))
        if (res?.meta?.requestStatus === 'fulfilled') {
            handleClose()
            showToast('success', 'Order placed successfully')
            setSubmitting(false)             // <-- added
        } else if (res?.meta?.requestStatus === 'rejected') {
            showToast('error', res.payload)
            setSubmitting(false)             // <-- added
        }
    }

    // timer
    const [timer, setTimer] = useState(25);

    useEffect(() => {
        const interval = setInterval(() => {
            setTimer(timer => timer - 1);
        }, 1000);
        return () => clearInterval(interval);
    }, [timer]);

    useEffect(() => {
        if (timer === 0) {
            handleClose();
        }
    }, [timer, handleClose]);

    useEffect(() => {
        if (ref?.current) {
            setTimer(25);
        }
    }, [ref]);

    return (
        <CustomModal
            handleClose={handleClose}
            handleSubmit={handleSubmit}
            timer={timer}
            modalTitle={`Sell Contract`}
            modalTitleColor={'#EB6969'}
            buttonText={'Sell'}
            className='modal-button-danger'
            disabled={submitting || state.volume === '' || selectedContract.ask === 0}
            ref={ref}
        >
            <Box className='flex flex-col gap-3'>
                <Box className='flex gap-3'>
                    <Typography>Contract:</Typography>
                    <Typography color={'black'}>{selectedContract.name}</Typography>
                </Box>
                <FormControl fullWidth>
                    <InputLabel
                        id="demo-simple-select-label"
                        sx={{ bgcolor: '#F5F5F5', pr: 1 }}
                    >
                        Sell To
                    </InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Sell To"
                        name="buyer"
                        value={state.buyer}
                        onChange={handleChange}
                    >
                        {user?.CanSellElectricityTo?.map((sellto, index) => (
                            <MenuItem key={index} value={sellto}>{sellto}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <FormControl fullWidth variant="outlined">
                    <InputLabel
                        id="contractLabel"
                        sx={{ bgcolor: '#F5F5F5', p: '0 3px' }}
                    >
                        Volume
                    </InputLabel>
                    <OutlinedInput
                        id="volume"
                        label="Volume"
                        name="volume"
                        required
                        type="number"
                        onChange={handleChange}
                        value={state.volume}
                        inputProps={{ step: 0.01, min: 0 }}
                        endAdornment={
                            <InputAdornment position="start" sx={{ ml: 2 }}>
                                MW
                            </InputAdornment>
                        }
                    />
                </FormControl>
                <Box className='flex gap-3'>
                    <Typography>Price:</Typography>
                    <Typography color={'black'}>{selectedContract.bid.toFixed(3)}</Typography>
                </Box>
                <Box className='flex gap-3'>
                    <Typography>Settlement Price:</Typography>
                    <Typography color={'black'}>{selectedContract?.bid * state?.volume || 0}</Typography>
                </Box>
                <Box className='flex gap-3'>
                    <Typography>Currency:</Typography>
                    <Typography color={'black'}>CHF</Typography>
                </Box>
            </Box>
        </CustomModal>
    )
})

export default Sell